import { create } from "zustand";
import { persist } from "zustand/middleware";
import { ACCOUNT_TYPES } from "commons/constants";

const useAuthStore = create(
  persist(
    (set, get) => ({
      userData: null,
      token: null,
      loading: true,
      isRootUser: false, //refers to account type of COMMUNITY_LEAD
      isOwner: false, //true when the logged-in phone owns the account (vs delegated member)
      isProxy: false, //true for super-admin proxy (impersonation) sessions
      isAuthenticated: false,
      setAuth: (payload) => {
        set(payload);
      },
      setUserData: ({ user, token }) => {
        set({
          userData: user,
          token,
          loading: false,
          isRootUser: user?.account_types?.includes(
            ACCOUNT_TYPES.COMMUNITY_LEAD
          ),
          isOwner: Boolean(user?.is_owner),
          isProxy: Boolean(user?.is_proxy),
          isAuthenticated: Boolean(token && user?.account_id),
        });
      },
      updateProfileData: (profileData) => {
        const currentUserData = get().userData;
        set({
          userData: {
            ...currentUserData,
            ...profileData,
          },
        });
      },
      clearUserData: () => {
        set({
          userData: null,
          token: null,
          isRootUser: false,
          isOwner: false,
          isProxy: false,
          isAuthenticated: false,
        });
      },
    }),
    {
      name: "user-data",
      getStorage: () => localStorage,
      partialize: (s) => ({
        token: s.token,
        userData: s.userData,
        onboardingDraft: s.onboardingDraft,
      }),
      merge: (persisted, current) => {
        if (!persisted) return current;
        return {
          ...current,
          token: persisted.token ?? current.token,
          userData: persisted.userData ?? current.userData,
          onboardingDraft: persisted.onboardingDraft ?? current.onboardingDraft,
          isAuthenticated: Boolean(
            persisted.token && persisted.userData?.account_id
          ),
          isRootUser: persisted.userData?.account_types?.includes(
            ACCOUNT_TYPES.COMMUNITY_LEAD
          ) ?? false,
          isOwner: Boolean(persisted.userData?.is_owner),
          isProxy: Boolean(persisted.userData?.is_proxy),
          loading: false,
        };
      },
    }
  )
);

export default useAuthStore;
